import { useOrder } from "@repo/api";
import { t } from "@repo/translation";
import { DebouncedSearchField } from "@repo/ui";
import { SectionContainer } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";
import { useEffect } from "react";

import { SearchResultHandler } from "../../components/SearchResultHandler";
import { isOrderNumber } from "../../hooks/searchOrder";
import {
  type AddOrderState,
  type AddOrderStateActions,
} from "./AddOrderReducer";

interface SearchStepProps {
  actions: AddOrderStateActions;
  state: AddOrderState;
}

export const SearchCustomerOrders = ({ actions, state }: SearchStepProps) => {
  const { searchValue } = state;
  const isSearchOnOrder = isOrderNumber(state.searchValue);
  let searchOrder;
  if (isSearchOnOrder) {
    searchOrder = state.searchValue;
  }

  const { data: orderData, isValidating: isOrderLoading } =
    useOrder(searchOrder);

  const isValidating = isOrderLoading;

  useEffect(() => {
    if (orderData) {
      actions.setOrders([
        {
          orderStatus: orderData.orderStatus,
          orderNo: orderData.orderNo,
          orderCreationDate: orderData.orderCreationDate,
          orderType: orderData.orderType,
          orderAmount: orderData.orderValue,
          orderPaid: undefined,
          currencyCode: orderData.currencyCode,
        },
      ]);
    }
  }, [orderData, actions]);

  const hasManualSearchResult = !isValidating && searchValue !== undefined;

  return (
    <SectionContainer>
      <DebouncedSearchField
        id="search-order-input"
        placeholder={t("prompt.search_with_order_number")}
        debounceTime={700}
        onChange={(term) => {
          actions.setSearchValue(term || undefined);
          trackAnalytics("search_with_email_or_order_number");
        }}
      />
      <SearchResultHandler
        isValidating={isValidating}
        isNoData={!orderData && hasManualSearchResult}
        searchValue={searchValue}
      />
    </SectionContainer>
  );
};
